import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} registrado en tu zona",
  "alert.toast.escalation": "{hazard} cercano ha escalado de gravedad",
  "alert.toast.inPath": "{hazard} avanza en dirección a tu ubicación",
  "alert.toast.allClear": "Situación normalizada cerca de {place}",
  "alert.toast.tap": "Abrir para consultar detalles y medidas de seguridad",
  "alert.takeover.title": "{hazard} — acción inmediata requerida",
  "alert.takeover.details": "Consultar informe completo",
  "now.status.allClear": "Sin peligros activos.",
  "now.status.stayAware": "Mantén la vigilancia.",
  "now.status.sub.allClear": "Sin peligros activos dentro de tu radio de vigilancia.",
  "now.activity.empty": "Sin actividad registrada en las proximidades.",
  "onboarding.promise.tagline": "Una red comunitaria de alerta temprana.",
  "onboarding.promise.continue": "Iniciar",
  "region.unsupported.title": "Ubicación fuera del área de cobertura",
  "you.voice.intro": "Selecciona el tono con el que Beacon se comunica.",
};
